import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// noBorder/shadow are accepted (Modal passes them) but not used
/** @param {{ children?: any, className?: string, variant?: string, noBorder?: boolean, shadow?: boolean }} props */
export const Card = ({ children, className, variant }) => (
  <div className={classNames('card', className, variant)}>
    {children}
    <style >{`

      .card {
        background: var(--reverse);
        box-sizing: border-box;
        border-radius: var(--radius-md);
        padding: var(--spacing-md);
      }
      
      .card.dark {
        background-color: var(--blue-dark);;
      }
    `}</style>
  </div>
);

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export const CardHeader = ({ children }) => (
  <header className="card-header">
    <h2>{children}</h2>
    <style >{`
      h2 {
        font-size: 1.375rem;
        margin: 0px;
      }

      & + :global(.card-body) {
        margin-top: var(--spacing-lg);
      }
    `}</style>
  </header>
);
CardHeader.propTypes = {
  children: PropTypes.node,
};

export const CardBody = ({ children }) => (
  <div className="card-body">
    {children}
    <style >{`
      .card-body {
        color: var(--text-mid);
      }

      & + :global(.card-footer) {
        margin-top: var(--spacing-md);
      }
    `}</style>
  </div>
);
CardBody.propTypes = {
  children: PropTypes.node,
};

export const CardFooter = ({ children, divider = false, flex = false }) => (
  <footer className={classNames('card-footer', { divider, flex })}>
    {children}
    <style >{`
      .card-footer {
        display: flex;
        margin-top: 1em;
      }

      :global(.card-footer.flex > *) {
        flex: 1;
      }

      .card-footer.divider {
        border-top: 1px solid var(--gray-light);
        padding-top: var(--spacing-md);
      }
    `}</style>
  </footer>
);
CardFooter.propTypes = {
  children: PropTypes.node,
  divider: PropTypes.bool,
  flex: PropTypes.bool,
};

export default Card;
